export const getSelectValue = (options, values) =>
  options.filter((opt) => values.includes(opt.value));
